import React,{useState,useCallback} from 'react'
import { useTranslation } from "react-i18next";
import styles from './ModuleRecords.module.css'
import { Tabs, Tab } from 'react-bootstrap';
const ModuleRecords = (props) => {
    const [activeTab, setActiveTab] = useState('all')
    const [t] = useTranslation('crm')
    const onNewTabSelectedHandler = useCallback((newTab) => {
        setActiveTab(newTab)
    }, [])

    return (
        null
    )
}
export default ModuleRecords